// This file is loaded both on legacy and new layouts and should be moved into application-next
// when we don't have the old layouts anymore (or we don't need the hybrid layouts with AblyUi on legacy pages.)

import React from 'react';

import guiSprites from '@ably/ui/core/sprites-gui.svg';
import displaySprites from '@ably/ui/core/sprites-display.svg';
import socialSprites from '@ably/ui/core/sprites-social.svg';
import techSprites from '@ably/ui/core/sprites-tech.svg';

import { loadSprites, SessionDataProvider } from '@ably/ui/core/scripts';

import turboMount, { registerComponent } from '@/global/turbo-mount';
import Footer from '@ably/ui/core/Footer';
import Meganav from '@ably/ui/core/Meganav';
import Flash, { FlashProvider } from '@ably/ui/core/Flash';
import Status from '../components/react/status';

import './ably-ui/insights';

// Flash component wrapped with provider
const FlashWithProvider = (props: React.ComponentProps<typeof Flash>) =>
  React.createElement(FlashProvider, null, React.createElement(Flash, props));

FlashWithProvider.displayName = 'FlashWithProvider';

// HOC to wrap components with SessionDataProvider
const withSessionData = <P extends object>(Component: React.ComponentType<P>) => {
  const WrappedComponent = (props: P) => {
    const sessionDataUrl = document.body.dataset.apiSessionData;
    return React.createElement(SessionDataProvider, { sessionDataUrl }, React.createElement(Component, props));
  };
  WrappedComponent.displayName = `withSessionData(${Component.displayName || Component.name || 'Component'})`;
  return WrappedComponent;
};

const MeganavWithSessionData = withSessionData(Meganav);

registerComponent(turboMount, 'Meganav', MeganavWithSessionData);
registerComponent(turboMount, 'Footer', Footer);
registerComponent(turboMount, 'Flash', FlashWithProvider);
registerComponent(turboMount, 'Status', Status);

document.addEventListener('DOMContentLoaded', () => {
  // Inserts sprite maps for <use> tags
  loadSprites([guiSprites, displaySprites, socialSprites, techSprites]);

  // Session data now automatically fetched by SessionDataProvider
});
